import { Request, BaseApiUrl } from "./api";

// 获取任务列表
export const getGetRecipeTask = (params) => {
  return Request.get(`${BaseApiUrl}/api/ProdTask/GetRecipeTask`, { params: params });
};

// 获取任务列表
export const getProdRecipeGet = (params) => {
  return Request.get(`${BaseApiUrl}/api/ProdRecipe/Get`, { params: params });
};

// 获取生产线
export const getSysStationLineListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/SysStationLine/get`, { params: params });
};


//获取详情
export const getProdRecipeDetail = (params) => {
  return Request.get(`${BaseApiUrl}/api/ProdRecipe/Detail`, { params: params });
};
// 任务配比上传
export const sendTask = (params) => {
  return Request.get(`${BaseApiUrl}/api/ProdTask/SendTask`, { params: params });
};
//获取详情根据Code获取最新的
export const getProdRecipeDetailByCode = (params) => {
  return Request.get(`${BaseApiUrl}/api/ProdRecipe/DetailByCode`, { params: params });
};